import { SET_USER_LOCATION, WAITING_FOR_GPS } from '../actions/currentUser';

export default function(state = {}, action) {
  switch (action.type) {
    case SET_USER_LOCATION:
      return {
        ...state,
        userLocation: action.payload,
      };
    case WAITING_FOR_GPS:
      return {
        ...state,
        waitingForGps: action.payload,
      };
    default:
      return state;
  }
}
